import { useEffect, useState } from "react";

import { Button, Line, ModalBody, ModalHeader, P, toast } from "@sorcery/ui";

import { useModal } from "~/providers/ModalProvider";
import { api } from "~/utils/trpc";

export const CollectionDeleteModal = () => {
  const { closeModal } = useModal();

  const [error, setError] = useState("");
  const trpcUtils = api.useUtils();

  const { mutateAsync: deleteCollection, error: trpcError } = api.collection.delete.useMutation({
    onSuccess: () => {
      toast("Collection deleted");
      void trpcUtils.collection.getBySession.invalidate();
      void trpcUtils.collection.getCollectionlistBySession.invalidate();
      void trpcUtils.collection.search.invalidate();
      void trpcUtils.user.getBySession.invalidate();
      closeModal();
    },
  });

  // Track trpc errors for display
  useEffect(() => {
    if (trpcError) {
      // don't expose server side error messages
      setError("Something went wrong.");
    }
  }, [trpcError]);

  const onSubmit = () => {
    // clear errs
    setError("");
    void deleteCollection();
  };

  return (
    <div className="p-6">
      {/* header */}
      <ModalHeader title="Delete Collection" />

      <ModalBody>
        {/* item */}
        <div className="mb-2 w-full">
          <P>Are you 100% sure you want to delete your collection?</P>
          <P>This is permanent and cannot be undone.</P>

          {error && (
            <div className="text-red my-4" role="alert">
              <p>
                <span className="font-bold">Error. </span>
                {error}
                <span>.</span>
              </p>
            </div>
          )}
        </div>
      </ModalBody>

      {/* footer */}
      <Line />
      <div className="flex flex-row-reverse pt-4 gap-2">
        <Button variant="destructive" onClick={onSubmit}>
          Confirm Delete
        </Button>
        <Button onClick={closeModal} variant="secondary">
          Cancel
        </Button>
      </div>
    </div>
  );
};
